<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('b2b_self_test_pain_worst_question')"
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b_self_test_pain_worst_description')"
        />
      </div>
      <ScoreSlider
        :label="getScoreSliderLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_pain_intensity_severe_pain')"
        :min-text="$t('b2b_self_test_pain_intensity_no_pain')"
        :score="getScoreSliderValue"
        data-qa="score-slider"
        @change="handleSliderChange"
        @tap="handleSliderChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const reevaluationsStore = useSelfTestReevaluationStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const painWorst = computed(() => reevaluationsStore.painWorst)

const isValid = computed(() => painWorst.value >= 0 && painWorst.value <= 10)

const getScoreSliderValue = computed(() =>
  painWorst.value === -1 ? 5 : painWorst.value,
)

const getScoreSliderLabel = computed(() =>
  painWorst.value === -1 ? '' : `${painWorst.value}`,
)

const handleSliderChange = ({ value }) => {
  reevaluationsStore.painWorst = value
}
</script>
